// Single source of truth for the API base URL. Reads the build-time env var
// REACT_APP_API_BASE_URL (set in CI / .env); falls back to the local Herd
// host for dev. Anything that builds a URL by hand (blob downloads, CSV
// export) MUST import this instead of hardcoding — otherwise it bypasses the
// configured backend and silently hits the wrong host.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://smart-ca-saas.test/api";
